import { useQuery } from "@tanstack/react-query";
import { privateApi } from "../../../api/api";
import { DailyDetailResponseSchema } from "../response/DailyDetailResponse";

const API_VERSION = 'v3';

interface FilterProps {
    property_id: string;
    base_on: string;
    start_date: string;
    end_date: string;
    room_type_id?: string;
    source: string;
}

interface DailyDetailProps {
    filter?: FilterProps;
    enabled: boolean;
}

/**
 * Drill-down for one agent-report-daily row: every reservation-night behind
 * that row's total_earning (see AgentReportController::dailyReportDetail).
 */
const useDailyDetail = (params: DailyDetailProps) => {
    return useQuery({
        queryKey: [
            'report',
            'daily',
            'agent',
            'day',
            'detail',
            JSON.stringify(params.filter)
        ],
        queryFn: async () => {
            try {
                const response = await privateApi.get(`/${API_VERSION}/agent-report-daily-detail`, {
                    params: {
                        filter: params.filter
                    }
                });

                const validationResult = DailyDetailResponseSchema.safeParse(response.data);
                if (!validationResult.success) {
                    console.error("Validation failed:", validationResult.error.errors);
                    throw new Error("Invalid Agent report daily detail data format");
                }
                return validationResult.data;
            } catch (error) {
                console.error(`Failed to fetch Agent report daily detail`, error);
                throw error;
            }
        },
        enabled: params.enabled && !!params.filter && !!params.filter.property_id && !!params.filter.start_date && !!params.filter.end_date && !!params.filter.source,
        retry: import.meta.env.VITE_MAX_RETRY,
        refetchOnWindowFocus: false
    });
};

export default useDailyDetail;
